<template>
  <div class="">
    <!-- Top banner section -->
    <AppBanner />

    <!-- Video toggle section -->
    <AppVideoLibrary />
  </div>
</template>

<script>
import AppBanner from '@/components/how-it-works-components/AppBanner.vue'
import AppVideoLibrary from '@/components/how-it-works-components/AppVideoLibrary.vue'

export default {
  name: 'HowItWorks',
  components: {
    AppBanner,
    AppVideoLibrary
  }
}
</script>

<style scoped>
/* Your styles */
</style>



// WEBPACK FOOTER //
// src/views/content/how-it-works-new/index.vue